export enum PaymentType {
  DOMUSO_CASH = "DOMUSO_CASH",
  RENT = "RENT",
}

export enum AutopayFields {
  PAYMENT_AMOUNT = "paymentAmount",
  PAYMENT_DATE = "paymentDate",
}

export enum PaymentActionTypes {
  PAYMENT_CANCELLED = "PAYMENT_CANCELLED",
  PAYMENT_STARTED = "PAYMENT_STARTED",
  PAYMENT_IN_REVIEW = "PAYMENT_IN_REVIEW",
  PAYMENT_CREATED = "PAYMENT_CREATED",
  PAYMENT_SOURCE_UPDATED = "PAYMENT_SOURCE_UPDATED",
  PAYMENT_SOURCE_DELETED = "PAYMENT_SOURCE_DELETED",
}
